// useMessage.ts
import { useCallback } from "react"
import { useIntl } from "react-intl"
import { MessageIdType, MessageValuesType, messageMap } from "./typeSafeMapping"

export function useMessage() {
    const intl = useIntl()

    const t = useCallback(
        (id: MessageIdType, values?: MessageValuesType) =>
            intl.formatMessage(messageMap[id], values),
        [intl]
    )

    return { t }
}
